import * as React from "react";

const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    id="Layer_1_iso_right"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 120 64.5"
    style={{
      enableBackground: "new 0 0 120 64.5",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {`
        .iso_ir_st0{display:none;fill:none;stroke:${strokeColor};stroke-width:0.6042;stroke-miterlimit:10;}
        .iso_ir_st1{fill:none;stroke:${strokeColor};stroke-width:0.6042;stroke-miterlimit:10;}
        .iso_ir_st2{display:none;fill:none;stroke:${strokeColor};stroke-width:0.7549;stroke-miterlimit:9.9982;}
        .iso_ir_st3{display:none;}
        .iso_ir_st4{display:inline;fill:none;stroke:${strokeColor};stroke-width:0.7549;stroke-miterlimit:10;}
        .iso_ir_st5{display:none;fill:none;stroke:${strokeColor};stroke-width:0.7549;stroke-miterlimit:10;}
        .iso_ir_st6{fill:none;stroke:${strokeColor};stroke-width:0.6027;stroke-miterlimit:10;}
        .iso_ir_st7{fill:none;stroke:${strokeColor};stroke-width:0.4531;stroke-miterlimit:10;}
        .iso_ir_st8{fill:none;stroke:${strokeColor};stroke-width:0.6042;stroke-miterlimit:9.9961;}
        .iso_ir_st9{fill:none;stroke:${strokeColor};stroke-width:0.6027;stroke-miterlimit:10.0006;}
      `}
    </style>
    <g id="Layer_1_00000057866519123740642160000007098581999562517395_">
      <g id="Layer_1_00000052815706336185140060000010184608169179766144_">
        <g id="Layer_1_00000124843414886120022300000008603847642599627423_">
          <g id="Layer_1_00000168803079670745848200000003522177890262615425_">
            <g id="Layer_2_00000005953711694740312420000001306363711486528651_" />
            <g id="Layer_1_00000103222774645540541050000005139477364094571910_">
              <g id="Layer_4_00000049934109083756324810000015099088110705302955_">
                <path
                  className="iso_ir_st0"
                  d="M69.5,36.7c5.2,2.2,4.7,12.4,4.9,14.9c0,0,0,0,0,0.3"
                />
                <path
                  className="iso_ir_st1"
                  d="M69.9,41.8L69.9,41.8c-1.4-2.1-2.1-2.9-2.4-2.8c0,0-11.6,3-15.6,3.5"
                />
                <path
                  className="iso_ir_st0"
                  d="M68.6,55c0.7-4.4-1.3-8.2-3.7-8.2c-2.4,0-5,3.2-5.5,7.6s1.3,8.2,3.7,8.2C65.8,62.8,68.1,59.6,68.6,55z"
                />
                <g id="Layer_2_00000035522350009171966180000007139185092383136160_">
                  <line
                    className="iso_ir_st0"
                    x1={72.7}
                    y1={52.2}
                    x2={102.9}
                    y2={42.4}
                  />
                  <path
                    className="iso_ir_st1"
                    d="M66,57c-13.6,7.4-27.5,4.2-54.2-5.2"
                  />
                </g>
              </g>
              <path className="iso_ir_st0" d="M68,28.8c0.7,1.7,2.2,4.9,1.7,8.1" />
            </g>
            <ellipse className="iso_ir_st2" cx={104.1} cy={45.8} rx={0.8} ry={0.8} />
            <g
              id="Layer_2_00000111192914016998989680000016321774623818434183_"
              className="iso_ir_st3"
            >
              <path
                className="iso_ir_st4"
                d="M93,54l0.8-4.6c0.8-8.4,4.8-20.8,12.6-22.4l1.3-0.3c6.7,0.2,7.3,7.8,8,14.1v2.1"
              />
            </g>
            <path
              className="iso_ir_st5"
              d="M101.6,30.1h2.9c10.7,0.4,9.6,12.8,9.4,15.3l-0.4,2.1c-1.9,12-11.1,15.9-18.5,10.7c-3.6-2.9-4-4.2-4-4.2"
            />
            <path className="iso_ir_st1" d="M52.4,42.4c-8.4,1.7-18.8-1.8-27-3.9" />
          </g>
          <path className="iso_ir_st6" d="M116,32" />
          <path
            className="iso_ir_st7"
            d="M104.4,13.9l1.3,0.2c0.5,0.2,0.8,0.2,1.3,0l0.5-0.2c0,0,0.2-0.2,0.7-0.2l2.2-0.2c0.2,0,0.5-0.2,0.5-0.5v-1 c0-0.2,0-0.5-0.5-0.5h-1.3c-0.5,0-0.8,0-1.3,0.2l-0.7,0.5l-0.5,0.8h-0.3L104.4,13.9"
          />
          <line className="iso_ir_st7" x1={106.4} y1={12.9} x2={107.1} y2={14.1} />
        </g>
        <g id="Layer_3">
          <g id="Layer_1_00000047040223050949772260000015762045760020518581_">
            <g id="Layer_4_00000178910712407868860300000017987189705786171814_">
              <g id="Layer_2_00000066493663017185536000000016878208057980606599_">
                <line className="iso_ir_st6" x1={80.6} y1={51} x2={109.3} y2={37.1} />
              </g>
            </g>
          </g>
          <path
            className="iso_ir_st1"
            d="M78.9,33.9c5.2,1.7,4.9,12.1,5,14.3c0,0,0.2,0.8,0.2,1.2"
          />
          <path
            className="iso_ir_st1"
            d="M78.4,51.7c0.5-3.9-1.2-7.2-3.5-7.4C72.7,44.1,70.4,47,70,51c-0.5,3.9,1.2,7.2,3.5,7.4 C75.7,58.6,77.9,55.5,78.4,51.7z"
          />
          <path className="iso_ir_st1" d="M64.6,43.3" />
          <path className="iso_ir_st1" d="M62.8,40.9" />
          <path className="iso_ir_st6" d="M111.3,25.8c-1.7,1-3.2,5.5-3.2,11.9" />
          <ellipse
            transform="matrix(9.653491e-02 -0.9953 0.9953 9.653491e-02 15.5505 120.5601)"
            className="iso_ir_st8"
            cx={74.2}
            cy={51.7}
            rx={0.7}
            ry={0.5}
          />
          <ellipse className="iso_ir_st9" cx={112.8} cy={34.9} rx={0.3} ry={0.8} />
          <path
            className="iso_ir_st1"
            d="M66,57.2l0.2-2c0.8-7.9,3.7-16.5,9.4-17.6l1-0.2c6.5-0.5,5.5,12.9,5.5,12.9"
          />
          <path
            className="iso_ir_st1"
            d="M71.7,39.9h2c7.6,0.3,6.9,9.2,6.7,10.9l-0.2,1.3c-1.3,8.4-8.1,11.4-13.1,7.9c-1.7-1.2-2.2-2.7-2.2-2.7"
          />
          <path
            className="iso_ir_st6"
            d="M115.5,32.6L115.5,32.6v-2c-0.3-3.9-2.5-3.7-2.5-3.7c-2.2,0.2-3.4,5.2-3.9,10.4"
          />
        </g>
        <polygon
          className="iso_ir_st1"
          points="26.7,38.9 10.7,35.1 11.6,29.3 27,32.5  "
        />
      </g>
      <path
        className="iso_ir_st6"
        d="M110.6,29.5l0.8-0.3c0.5-0.2,1-0.3,1.7-0.2c2.9,0.8,2.4,4.8,2.4,5.6l0,0.9c-0.7,4.2-4.2,5.7-6.7,4 c-0.8-0.5-1.2-1.5-1.2-1.5"
      />
      <path
        className="iso_ir_st6"
        d="M114.8,34.9c0.3-2.2-0.7-4-1.8-4c-1.2-0.2-2.5,1.5-2.7,3.7c-0.3,2.2,0.7,4,1.8,4 C113.3,38.7,114.6,37.1,114.8,34.9z"
      />
      <line className="iso_ir_st1" x1={43.1} y1={29.7} x2={42} y2={42.1} />
    </g>
  </svg>
);

export default SvgComponent;